<template>
  <svg width="15" height="13" viewBox="0 0 15 13"  xmlns="http://www.w3.org/2000/svg">
    <path
        d="M0 1.5C0 0.671573 0.719542 0 1.60714 0H13.3929C14.2805 0 15 0.671573 15 1.5C15 2.32843 14.2805 3 13.3929 3H1.60714C0.719543 3 0 2.32843 0 1.5Z"
        fill="currentColor"/>
    <path
        d="M0 6.5C0 5.67157 0.719542 5 1.60714 5H13.3929C14.2805 5 15 5.67157 15 6.5C15 7.32843 14.2805 8 13.3929 8H1.60714C0.719543 8 0 7.32843 0 6.5Z"
        fill="currentColor"/>
    <path
        d="M0 11.5C0 10.6716 0.719542 10 1.60714 10H13.3929C14.2805 10 15 10.6716 15 11.5C15 12.3284 14.2805 13 13.3929 13H1.60714C0.719543 13 0 12.3284 0 11.5Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconBars"
}
</script>

<style scoped>

</style>